module.exports = __webpack_public_path__ + "static/media/email.4d22c318.png";